"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createMilestoneCameraSyncRequest = exports.MilestoneConnectionHeaderDefault = exports.MilestoneConnectionDefault = exports.DEFAULT_RTSP_PROTOCOL = exports.DEFAULT_RTSP_PORT = exports.DEFAULT_ONVIF_PORT = exports.DEFAULT_MILESTONE_BUFFER_MS = void 0;
var _uuid = require("uuid");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var DEFAULT_MILESTONE_BUFFER_MS = exports.DEFAULT_MILESTONE_BUFFER_MS = 800;
var DEFAULT_ONVIF_PORT = exports.DEFAULT_ONVIF_PORT = 580;
var DEFAULT_RTSP_PORT = exports.DEFAULT_RTSP_PORT = 554;
var DEFAULT_RTSP_PROTOCOL = exports.DEFAULT_RTSP_PROTOCOL = "rtsp://";
var MilestoneConnectionHeaderDefault = exports.MilestoneConnectionHeaderDefault = function MilestoneConnectionHeaderDefault() {
  return {
    id: {
      value: (0, _uuid.v4)()
    },
    name: "",
    description: "",
    bridgeHost: "",
    onvifPort: DEFAULT_ONVIF_PORT,
    onvifTls: false,
    rtspPort: DEFAULT_RTSP_PORT,
    rtspTls: false,
    username: "",
    password: "",
    useDigest: true,
    adjustTime: false,
    streamPath: "live",
    bufferMs: DEFAULT_MILESTONE_BUFFER_MS
  };
};
var MilestoneConnectionDefault = exports.MilestoneConnectionDefault = function MilestoneConnectionDefault() {
  return _objectSpread(_objectSpread({}, MilestoneConnectionHeaderDefault()), {}, {
    isConnected: false,
    rtspProtocol: DEFAULT_RTSP_PROTOCOL
  });
};
var createMilestoneCameraSyncRequest = exports.createMilestoneCameraSyncRequest = function createMilestoneCameraSyncRequest(connectionId) {
  var cameraGuids = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return {
    connectionId: {
      value: connectionId
    },
    cameraGuids: cameraGuids
  };
};